import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Form } from '../../components';
import EditListingPackagesSection from './EditListingPackagesSection';

const hourly = {
  pricingModel: 'hourly',
  price: 12000,
  title: 'Content strategy by the hour',
  description:
    '<p>Flexible senior support for your content work. I help you define audiences, key messages and channel roles, audit existing content and build a realistic publishing plan your team can run with. Billed by the hour, reported weekly.</p>',
};

const project = {
  pricingModel: 'project',
  price: 240000,
  title: 'Content strategy',
  description:
    '<p>A complete content strategy for your brand in four weeks: audience and competitor review, messaging framework, channel plan and a 3-month editorial calendar. Includes two workshops with your team and a final presentation.</p>',
};

const draftDescription =
  '<p>A monthly content package with four blog posts and social media versions of each post. Includes a monthly planning call and a short report on results.</p>';

const PackagesForm = props => (
  <FinalForm
    {...props}
    onSubmit={() => null}
    mutators={{ ...arrayMutators }}
    render={({ handleSubmit }) => (
      <Form onSubmit={handleSubmit} style={{ maxWidth: 880 }}>
        <EditListingPackagesSection />
      </Form>
    )}
  />
);

export const Empty = {
  component: PackagesForm,
  props: { initialValues: { packages: [], packageDraft: null } },
  group: 'service listing',
};

export const NewPackageIncomplete = {
  component: PackagesForm,
  props: {
    initialValues: {
      packages: [hourly],
      packageDraft: {
        pricingModel: '',
        price: null,
        title: 'Content strategy',
        description: draftDescription,
        __index: null,
      },
    },
  },
  group: 'service listing',
};

export const NewPackageReady = {
  component: PackagesForm,
  props: {
    initialValues: {
      packages: [hourly],
      packageDraft: {
        pricingModel: 'project',
        price: 240000,
        title: 'Content strategy',
        description: draftDescription,
        __index: null,
      },
    },
  },
  group: 'service listing',
};

export const AllReady = {
  component: PackagesForm,
  props: { initialValues: { packages: [hourly, project], packageDraft: null } },
  group: 'service listing',
};

export const EditingSaved = {
  component: PackagesForm,
  props: {
    initialValues: {
      packages: [hourly, project],
      packageDraft: { ...hourly, description: draftDescription, __index: 0 },
    },
  },
  group: 'service listing',
};

// A legacy listing: five old packages adapted to four, the first without a name.
export const LegacyFourPackages = {
  component: PackagesForm,
  props: {
    initialValues: {
      packages: [
        { pricingModel: 'project', price: 9900, title: '', description: 'Old plain-text package' },
        { ...project, title: 'Basic' },
        { ...project, title: 'Standard', price: 350000 },
        { ...project, title: 'Premium', price: 500000 },
      ],
      packageDraft: null,
    },
  },
  group: 'service listing',
};
